import funcomPrHubIcon from '@/pages/home/assets/img/studio/funcom-pr.png';
/** AI 顶栏枢纽卡片图：`assets/img/studio/ai-icon.png` */
import studioAiHubCardIcon from '@/pages/home/assets/img/studio/ai-icon.png';

export const PAGE_TYPE_DATABRAIN_PAGE = 'databrain_page';
/** 不用 as const：调用方均为 includes(后端返回的 string)，字面量联合会迫使每处断言 */
export const DATABRAIN_PAGE_TYPES: readonly string[] = [PAGE_TYPE_DATABRAIN_PAGE];
export const DATABRAIN_LINK_PAGE_PATH = 'databrainLink';

export const STUDIO_OPERATION = 'operation';
export const STUDIO_DEVELOPMENT = 'development';

/**
 * 工作台路由唯一配置表（除 Umi 路由外，新增同类 hub 原则上只改此处一行）。
 * - segment：URL `/studio/:id/:segment` 与 studio_dashboard_list[].path 根段一致
 * - basePath：与接口菜单 path 一致（含前导 /）
 * - headerHub：是否作为 Studio 顶栏「枢纽」入口（与 studio_dashboard_list 联动）
 * - wrapGameSidebar：StudioWrap 内是否展示左侧游戏侧栏（PR=true；AI=false，内容区全宽）
 * - headerHubCardImage：顶栏枢纽卡片固定图（打包静态资源；不配则仅用 studio_info.element_url，再无则为空）
 */
export const STUDIO_HUB_ROUTE_ENTRIES = [
  {
    key: 'HOME',
    segment: 'home',
    basePath: '/home',
    headerHub: false,
    wrapGameSidebar: false,
  },
  {
    key: 'PR',
    segment: 'pr',
    basePath: '/pr',
    headerHub: true,
    wrapGameSidebar: true,
    headerHubCardImage: funcomPrHubIcon,
  },
  {
    key: 'AI',
    segment: 'ai-report',
    basePath: '/ai-report',
    headerHub: true,
    wrapGameSidebar: false,
    headerHubCardImage: studioAiHubCardIcon,
  },
  {
    key: 'DATABRAIN_LINK',
    segment: DATABRAIN_LINK_PAGE_PATH,
    basePath: `/${DATABRAIN_LINK_PAGE_PATH}`,
    headerHub: true,
    wrapGameSidebar: false,
  },
] as const;

type THubRouteEntry = (typeof STUDIO_HUB_ROUTE_ENTRIES)[number];
type THubRouteKey = THubRouteEntry['key'];

export type StudioHubShellKind = THubRouteEntry['segment'];

/** 兼容旧代码：`STUDIO_HUB_SHELL.PR` 等与 URL segment 一致 */
export const STUDIO_HUB_SHELL = Object.freeze(
  Object.fromEntries(
    STUDIO_HUB_ROUTE_ENTRIES.map(e => [e.key, e.segment]),
  ) as Record<THubRouteKey, StudioHubShellKind>,
);

/** Studio 工作台路径（由 {@link STUDIO_HUB_ROUTE_ENTRIES} 导出，便于按常量引用） */
export const STUDIO_HUB_PATH_HOME = STUDIO_HUB_ROUTE_ENTRIES.find(
  e => e.segment === STUDIO_HUB_SHELL.HOME,
)!.basePath;

export const STUDIO_HUB_PATH_PR = STUDIO_HUB_ROUTE_ENTRIES.find(
  e => e.segment === STUDIO_HUB_SHELL.PR,
)!.basePath;

export const STUDIO_HUB_PATH_AI = STUDIO_HUB_ROUTE_ENTRIES.find(
  e => e.segment === STUDIO_HUB_SHELL.AI,
)!.basePath;

export const STUDIO_HUB_SEGMENTS = STUDIO_HUB_ROUTE_ENTRIES.map(
  e => e.segment,
) as readonly StudioHubShellKind[];

/** StudioWrap 左侧游戏侧栏：仅 wrapGameSidebar=true 的 segment（当前为 PR） */
export function isStudioSidebarGameHubSegment(
  segment: StudioHubShellKind,
): boolean {
  return STUDIO_HUB_ROUTE_ENTRIES.some(
    e => e.segment === segment && e.wrapGameSidebar,
  );
}

export const STUDIO_TAB_LIST = [
  STUDIO_OPERATION,
  STUDIO_DEVELOPMENT,
] as const;

export type TStudioTab = typeof STUDIO_OPERATION | typeof STUDIO_DEVELOPMENT;
